

//const videoURL = "http://localhost:3000/20150712_151612.mp4"; // "https://www.youtube.com/watch?v=ZaYvwn9nBD4";

import { Button, Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom"
import FileSaver from "file-saver";
import XLSX from "sheetjs-style"
import { IDadosExportSalarios, JogadorService } from "../../services/api/jogador/JogadorService";
import { IDadosModal } from "../modal/DialogMensagem";
import SaveIcon from '@mui/icons-material/Save';
import LoadingButton from '@mui/lab/LoadingButton';
import { UtilidadeService } from "../../services/api/utilidades/UtilidadesService";

//const IFrameUrl = "https://g1.globo.com/inovacao/noticia/2023/04/20/spacex-lanca-starship-a-nave-mais-potente-da-historia.ghtml" //"https://open.spotify.com/episode/7mMA5Z091KnXeruZAoHNNu?si=xYutzhHxTWCvAL_XKlieHQ&nd=1"
//const IFrameUrl = "<iframe style="border-radius:12px" src="https://open.spotify.com/embed/episode/7mMA5Z091KnXeruZAoHNNu?utm_source=generator" width="100%" height="352" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>"
//const IFrameUrl = "https://blog.tecnospeed.com.br/nfce-com-csharp-ou-c/"



export type IExportProps = {

    children?: React.ReactNode;
    nomeArquivo: string;
}
export const DonwloadSalarios: React.FC<IExportProps> = ({ nomeArquivo }) => {
    //const [dados, setDados] = useState<IDadosExportSalarios[]>([]);
    const [showModalMensagem, setShowModalMensagem] = useState(false);
    const [loading, setLoading] = useState(false);
    const [redirecionar, setRedirecionar] = useState("0");
    let codLocal = localStorage.getItem("@codigoLiga");
    const [codigoLiga, setCodigoLiga] = useState(codLocal !== null ? UtilidadeService.decrypt(codLocal) : "0");
    const [dadosModal, setDadosModal] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "error",
        mensagem: "Exportação não realizada!",
        display: "none",
        titulo: "Atenção"
    });
    const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml,sheet;charser=UTF-8";
    const fileExtension = ".xlsx";

    const CarregarDadosExportSalariosNba = async () => {
        setLoading(true);
        if (codigoLiga !== undefined && Number(codigoLiga) > 0) {
            await JogadorService.getDadosSalariosTemporada(Number(codigoLiga), Number(localStorage.getItem("@codigoTemp")))
                .then((result) => {
                    setLoading(false);
                    setShowModalMensagem(false);
                    exportToExcel(result.dado);
                }).catch((errors) => {
                    setShowModalMensagem(true);
                    if (errors.response !== undefined && errors.response.status === 401) {
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        setRedirecionar("-1");
                        return;
                    }
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                });
        }

    }

    const exportToExcel = async (dados: IDadosExportSalarios[]) => {
        const ws = XLSX.utils.json_to_sheet(dados);
        const wb = { Sheets: { "data": ws }, SheetNames: ["data"] };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, nomeArquivo + fileExtension);
    }
    return (
        <>
            <Tooltip title="Exportar Salários">
                <LoadingButton variant="contained"
                    onClick={(e) => CarregarDadosExportSalariosNba()} color="primary"
                    style={{ cursor: "pointer" }}
                    endIcon={<SaveIcon />}
                    loading={loading}
                    loadingPosition="end"

                >
                    Exportar Salários NBA
                </LoadingButton >
            </Tooltip>
        </>

    )
}